export default __webpack_public_path__ + "static/media/url-shorteningImg_1.ae9f3f56.webp";